import React from "react"

const FloorList = ({ list, onChangeFloor, current }) => {
  return (
    <div className="floor-selector">
      {list.map(floor => (
        <div
          className={
            "floor" + (floor.floor === current.floor ? " clicked" : "")
          }
          key={floor.floor}
          onClick={() => {
            onChangeFloor(floor)
          }}
        >
          {floor.name}
        </div>
      ))}
    </div>
  )
}

export default FloorList
